import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const CareCosmetics = lazyWithPreload(() => import('./CareCosmetics'))
export const LikeChatCareCosmetics = lazyWithPreload(
  () => import('./LikeChatCareCosmetics'),
)
export const CareCosmetics3 = lazyWithPreload(() => import('./CareCosmetics3'))
